# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/


#TODO: Need to deal with errors fields?

window.append_to_id = (obj, suffix) ->
  obj.attr("id", obj.attr("id") + suffix)
  return obj

window.replace_name = (obj, index) ->
  obj.attr("name", obj.attr("name").replace("**index**", index))
  return obj

window.rename_ids_and_set_callbacks = (container_selector, suffix, index) ->
  append_to_id($(container_selector + " #course-file-upload-field"), suffix)
  replace_name(append_to_id($(container_selector + " input[type='text']"), suffix), index)
  replace_name($(container_selector + " input.form-control ~ input[type='hidden']"), index)
  $(container_selector + " label.col-form-label").each(() ->
    $(this).attr("for", $(this).attr("for") + suffix)
  )
  clear_btn = append_to_id($(container_selector + " .clear-file-button"), suffix)
  input_obj = replace_name(append_to_id($(container_selector + " input.form-control"), suffix), index)
  $(container_selector + ' [data-bs-toggle="popover"]').popover()
  set_file_callbacks(clear_btn, input_obj)

$(document).on "turbolinks:load", ->
  
#  $("#open-new-file-dialog").on("click", (e) ->
#    $("#file-new-form-content").html($("#blank-fields")[0].innerHTML)
#    rename_ids_and_set_callbacks("#file-new-form-content", "-0", 0)
##    append_to_id($("#file-new-form-content label.custom-file"), "-0")
##    append_to_id($("#file-new-form-content input[type='text']"), "-0")
##    $("#file-new-form-content label.col-form-label").each(() ->
##      $(this).attr("for", $(this).attr("for") + "-0")
##    )
##    clear_btn = append_to_id($("#file-new-form-content .clear-file-button"), "-0")
##    input_obj = append_to_id($("#file-new-form-content input.form-control"), "-0")
##    set_file_callbacks(clear_btn, input_obj)
#    $("#file-new-popup").modal('show')
#  )
  
  $("#add-fields-btn").on("click", (e) ->
    last_id = $("#file-new-form-content > .copied-form-fields:last-of-type div.custom-file").parent().attr("id")
    new_id_num = parseInt(last_id.substring(last_id.search(/\d+$/))) + 1
    $("#file-new-form-content").append($("#blank-fields")[0].innerHTML)
    rename_ids_and_set_callbacks("#file-new-form-content > .copied-form-fields:last-of-type", "-" + new_id_num, new_id_num)
#    append_to_id($("#file-new-form-content > .copied-form-fields:last-of-type label.custom-file"), "-" + new_id_num)
#    append_to_id($("#file-new-form-content > .copied-form-fields:last-of-type input[type='text']"), "-" + new_id_num)
#    $("#file-new-form-content > .copied-form-fields:last-of-type label.col-form-label").each(() ->
#      $(this).attr("for", $(this).attr("for") + "-" + new_id_num)
#    )
#    clear_btn = append_to_id($("#file-new-form-content > .copied-form-fields:last-of-type .clear-file-button"), "-" + new_id_num)
#    input_obj = append_to_id($("#file-new-form-content > .copied-form-fields:last-of-type input.form-control"), "-" + new_id_num)
#    
#    set_file_callbacks(clear_btn, input_obj)
  )